/* Hook encargado de actualizar la fecha de expiracion

Autor: Benjamín León
Fecha: 2024-10-01
*/
import { useState } from 'react'

import { normalizeDate } from '../utils/utils.ts'
import { customPost } from '../utils/customFetch.ts'

import { makeUrlEstimateExtend } from './connectionData.tsx'

const apiUrl = makeUrlEstimateExtend()
const useEstimateExtend = () => {
  const [errorExtendEstimate, setErrorExtendEstimate] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const extendEstimate = async (id: string, expiresAt: string) => {
    setLoading(true)

    try {
      // Convertimos antes de enviar
      const expiresAtLZ = normalizeDate(expiresAt)

      await customPost(apiUrl, { _id: id, expiresAt: expiresAtLZ })

      setErrorExtendEstimate(null)
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorExtendEstimate(err)
      } else {
        setErrorExtendEstimate(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorExtendEstimate, loading, extendEstimate }
}
export default useEstimateExtend
